export default __webpack_public_path__ + "static/media/B231.92611d03.png";